import {http} from '@/helpers/http-helper';

class Bank {
    constructor(
        uuid,
        code,
        name
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
    }
}

class BankAccount {
    constructor(
        uuid,
        bank,
        code,
        entity,
        office,
        controlDigit,
        accountNumber,
        ccc
    ) {
        this.uuid = uuid;
        this.bank = bank;
        this.code = code;
        this.entity = entity;
        this.office = office;
        this.controlDigit = controlDigit;
        this.accountNumber = accountNumber;
        this.ccc = ccc;
    }
}

export const getBankAccounts = () => {
    return new Promise((resolve, reject) => {
        const url = 'banks/accounts';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let bankAccounts = [];
                    response.data.forEach((bankAccount) => {
                        let bank = !!bankAccount.bank
                            ? new Bank(bankAccount.bank.uuid, bankAccount.bank.code, bankAccount.bank.name)
                            : null;
                        bankAccounts.push(new BankAccount(
                            bankAccount.uuid,
                            bank,
                            bankAccount.code,
                            bankAccount.entity,
                            bankAccount.office,
                            bankAccount.controlDigit,
                            bankAccount.accountNumber,
                            bankAccount.ccc
                        ));
                    });
                    resolve(bankAccounts);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};